<template>
  <section class="section">
    <h4>Tetapkan Avatar</h4>
    <div :class="{avatar: true, hasPhoto: avatar, uploading: uploadingAvatar}"
      :style="{'background-image': `url(${avatar})`}" id="pickAvatar">
      <div class="avatarPlaceholder"></div>
      <span>Tetapkan Avatar</span>
    </div>
    <div class="info">Klik gambar diatas untuk
      mengganti tampilan avatar</div>
    <div class="actionCnt">
      <div class="theAction">
        <button class="btn secondary" v-on:click="skip"
          v-if="!formLoading">
          <span>Lewati</span></button>
        <button class="btn primary" v-on:click="doSave"
          :class="{btnLoading: formLoading}"><span>Berikutnya</span></button>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <AvatarCropper v-on:uploading="uploading" v-on:uploaded="uploaded"
      trigger="#pickAvatar" :upload-url="uploadUrl"
      :output-options="{width: 600, height: 600}"
      :upload-headers="uploadHeaders"
      :labels="{submit: 'Save Avatar', cancel: 'Cancel'}"/>
  </section>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';
import Confirmation from '@/components/Confirmation.vue';
import config from '../config';

export default {
  name: 'setAvatar',
  components: { Confirmation, AvatarCropper },
  data() {
    return {
      formLoading: false,
      avatar: null,
      uploadingAvatar: false,
      uploadUrl: '',
      uploadHeaders: {},
    };
  },
  created() {},
  destroyed() {},
  methods: {
    doNothing() {},
    uploading() {
      this.avatar = null;
      this.uploadingAvatar = true;
    },
    uploaded(response) {
      this.uploadingAvatar = false;
      this.avatar = response.avatar;
      this.$session.set('bk6_avatar', this.avatar);
    },
    skip() {
      if (!this.$session.get('bk6_character') || this.$session.get('bk6_character') === '') {
        this.$router.push('/character/choose');
      } else if (!this.$session.get('bk6_bmi') || this.$session.get('bk6_bmi') === '') {
        this.$router.push('/body-composition');
      } else {
        this.$router.push('/main');
      }
    },
    doSave() {
      if (!this.avatar) {
        this.$refs.confirmDialog.open({
          title: 'Lanjutkan tanpa avatar?',
          desc: `Kamu belum memilih avatar, apakah kamu ingin melanjutkan tanpa
            memilih avatar? Kamu bisa menambahkan avatar dari profil`,
          action: 'Lanjutkan',
        }, (b) => {
          if (!b) return;
          this.skip();
        });
      } else {
        this.skip();
      }
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
    this.avatar = this.$session.get('bk6_avatar');
    this.uploadUrl = this.$config.uri('user/avatar');
    this.uploadHeaders = {
      Key: config.apiKey,
      Authoziration: this.$session.get('bk6_jwt'),
    };
  },
};
</script>

<style lang="scss">
  .avatar-cropper-overlay{
    .avatar-cropper-mark{
      background-color: rgba(0,0,0,.6);
      backdrop-filter: saturate(180%) blur(20px);
    }
    .avatar-cropper-container{
      padding: 40px 80px;
      border-radius: 5px;
      @media (max-width: 960px) {
        padding: 20px 0;
        margin: 0 10px;
      }
    }
    .avatar-cropper-footer{
      margin: 20px -80px -40px;
      border-top: #eee 1px solid;
      padding: 12px 30px;
      display: block !important;
      text-align: right;
      @media (max-width: 960px) {
        padding: 12px 20px;
        margin: 20px 0 -20px;
      }
      button{
        margin-left: 10px;
        background-color: #78C90E !important;
        width: auto !important;
        color: #fff;
        padding: 10px 20px !important;
        border-radius: 4px;
        font-weight: bold;
        font-size: 18px;
        outline: 0 !important;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #006519 !important;
        }
        &:first-child{
          background-color: #fff !important;
          color: #78C90E !important;
          &:hover{
            background-color: #fff !important;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
.info{
  text-align: center;
  font-size: 15px;
  color: #767676;
  margin: 16px auto 0;
  max-width: 200px;
}
.section{
  padding: 30px 20px;
  min-height: 100vh;
  box-sizing: border-box;
  @media (max-width: 768px) {
    min-height: calc(100vh - 60px);
  }
  h4{
    color: #006519;
    font-weight: bold;
    font-size: 24px;
    margin: 0 0 20px;
    text-align: center;
  }
  .avatar{
    width: 240px; height: 240px;
    background-color: rgba(0, 0, 0, .1);
    border-radius: 50%;
    margin: 60px auto 0;
    position: relative;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
    transition: background-color .3s ease;
    &:hover{
      background-color: rgba(0, 0, 0, .2);
    }
    span{
      position: absolute;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      color: #767676;
      display: none;
    }
    .avatarPlaceholder{
      position: absolute;
      left: 0; right: 0; bottom: 0; top: 30px;
      background-image: url(../assets/user-avatar-placeholder.png);
      background-size: cover;
      opacity: .1;
    }
    &.uploading{
      background-image: url(../assets/loading.svg) !important;
      background-size: 54px auto !important;
      .avatarPlaceholder{
        display: none;
      }
    }
    &.hasPhoto{
      .avatarPlaceholder{
        display: none;
      }
    }
  }
  .actionCnt{
    position: fixed;
    left: 150px; right: 0; bottom: 0;
    @media (max-width: 768px) {
      left: 0;
    }
    .theAction{
      position: absolute;
      left: 20px; right: 20px; bottom: 40px;
      display: flex;
      @media (min-width: 480px) {
        width: 420px;
        left: 50%; right: auto;
        margin-left: -210px;
      }
      .btn.secondary{
        margin-right: auto;
        background: none;
        color: #006519;
        padding-left: 10px;
        text-transform: none;
        font-weight: 600;
        box-shadow: none;
      }
    }
  }
}
</style>
